import React from 'react';
import { Transfer } from 'antd';
import { connect } from 'react-redux';

import { serviceListLoad } from "store/models/service";
import { FormItem } from "utils";
import { ListLoadComponent } from 'components/common';


const ServiceTransferField = (props) => {
  return (
    <ListLoadComponent
      apiLoad={serviceListLoad}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, ...otherProps } = props;
        const dataSource = items.map(item => {
          item.key = item.id;
          return item;
        });
        return (
          <FormItem {...otherProps} valuePropName='targetKeys'>
            <Transfer
              dataSource={dataSource}
              showSearch
              listStyle={{
                width: 250,
                height: 300,
              }}
              render={item => `${item.name}`}
            />
          </FormItem>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.service,
});

export default connect(mapState)(ServiceTransferField);
